import { create } from 'zustand';

const useUserSettingsStore = create((set, get) => ({
  // Состояние
  keyPoints: [],
  isLoading: false,
  error: null,
  isOpen: false,
  
  // Действия
  fetchSettings: async () => {
    try {
      set({ isLoading: true, error: null });
      const token = localStorage.getItem('token');
      
      const response = await fetch(`${process.env.REACT_APP_API_URL}/users/settings`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (response.ok) {
        const settings = await response.json();
        set({ keyPoints: settings.key_points || [], isLoading: false });
        return settings;
      } else {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || 'Не удалось получить настройки пользователя');
      }
    } catch (error) {
      console.error('Error fetching settings:', error);
      set({ error: error.message, isLoading: false });
      return null;
    }
  },
  
  updateKeyPoints: async (keyPoints) => {
    try {
      set({ isLoading: true, error: null });
      const token = localStorage.getItem('token');
      
      const response = await fetch(`${process.env.REACT_APP_API_URL}/users/settings/key-points`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(keyPoints)
      });
      
      if (response.ok) {
        const settings = await response.json();
        set({ keyPoints: settings.key_points || [], isLoading: false });
        return settings;
      } else {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || 'Не удалось обновить ключевые пункты');
      }
    } catch (error) {
      console.error('Error updating key points:', error);
      set({ error: error.message, isLoading: false });
      throw error;
    }
  },
  
  resetSettings: async () => {
    try {
      set({ isLoading: true, error: null });
      const token = localStorage.getItem('token');
      
      const response = await fetch(`${process.env.REACT_APP_API_URL}/users/settings/reset`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (response.ok) {
        const settings = await response.json();
        set({ keyPoints: settings.key_points || [], isLoading: false });
        return settings;
      } else {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || 'Не удалось сбросить настройки пользователя');
      }
    } catch (error) {
      console.error('Error resetting settings:', error);
      set({ error: error.message, isLoading: false });
      throw error;
    }
  },
  
  // Локальные действия (без API)
  addKeyPoint: (keyPoint) => {
    if (keyPoint.trim()) {
      const currentKeyPoints = get().keyPoints;
      if (currentKeyPoints.length >= 10) {
        set({ error: 'Достигнуто максимальное количество ключевых пунктов (10)' });
        return;
      }
      const updatedKeyPoints = [...currentKeyPoints, keyPoint.trim()];
      set({ keyPoints: updatedKeyPoints });
    }
  },
  
  removeKeyPoint: (index) => {
    const updatedKeyPoints = [...get().keyPoints];
    updatedKeyPoints.splice(index, 1);
    set({ keyPoints: updatedKeyPoints });
  },
  
  editKeyPoint: (index, newText) => {
    if (newText.trim()) {
      const updatedKeyPoints = [...get().keyPoints];
      updatedKeyPoints[index] = newText.trim();
      set({ keyPoints: updatedKeyPoints });
    }
  },
  
  // Новые действия для управления видимостью
  openSettings: () => set({ isOpen: true }),
  closeSettings: () => set({ isOpen: false }),
  
  clearError: () => set({ error: null })
}));

export default useUserSettingsStore; 
